import { Card, CardContent, Typography, Box, Divider } from '@mui/material'
import { labTestAdviceCodeDetail } from '../../../utils/constants'

const MessagingCard = ({ record }) => {
  const adviceDetail = labTestAdviceCodeDetail.find((d) => d.value === record?.labTestAdviceCode)
  const isRestricted = ['pendingConfirmation', 'manualReview'].includes(record?.status)

  if (isRestricted) {
    return null
  }

  return (
    <Card>
      <CardContent>
        <Box>
          <Typography variant="subtitle1" fontWeight="bold">
            Lab note
          </Typography>
          <Typography variant="body1">{record?.labTestProviderNotes || '-'}</Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box>
          <Typography variant="subtitle1" fontWeight="bold">
            Patient messaging
          </Typography>
          <Typography variant="body1">{adviceDetail?.label ?? '—'}</Typography>
        </Box>
      </CardContent>
    </Card>
  )
}

export default MessagingCard
